import { cn } from "@/lib/utils";

/**
 * Calm status above the list while remote search is in flight — plan/33+35.
 * Local desk-open filtering stays silent (instant).
 */
export function ListSearchStatus(props: {
  /** False when filtering in-memory desk-open cache. */
  online: boolean;
  /** Debounce pending and/or server fetch for the current query. */
  searching: boolean;
  className?: string;
}) {
  if (!props.online || !props.searching) return null;
  return (
    <p
      className={cn(
        "mt-2 text-xs text-[var(--color-muted)] animate-[fadeIn_160ms_ease-out]",
        props.className,
      )}
      role="status"
      aria-live="polite"
    >
      Searching online…
    </p>
  );
}

/** Pending remote search: typing debounce and/or fetch for non-empty q. */
export function listSearchOnlinePending(opts: {
  query: string;
  debouncedQ: string;
  isFetching: boolean;
}): boolean {
  const typed = opts.query.trim();
  const committed = opts.debouncedQ.trim();
  if (typed !== committed) return true;
  return opts.isFetching && Boolean(committed);
}
